module.exports = __webpack_public_path__ + "static/media/11n.c6eecffc.svg";